export default "__VITE_ASSET__BLn4yb_9__"